import type React from 'react'

export function GestureActionView({children}: {children: React.ReactNode}) {
  return children
}
